import React from 'react';
import StripedTable from '../../../../../components/Table/StripedTable';
import Pagination from '../../../../../components/OtherElements/Pagination';
import { __ } from '../../../../../utils/i18n';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import BurstModeIcon from '@material-ui/icons/BurstMode';

const SlidersTable = React.memo((props) => {
  const { sliders, onPageChange, onDelete, onEdit } = props;
  const handlePageChange = (page) => {
    onPageChange(page);
  };
  const handleDeleteSlider = (id) => {
    onDelete(id);
  };
  const handleEditSlider = (id) => {
    onEdit(id);
  };
  const handleAddSlides = (id) => {
    props.onAddSlidesClick(id);
  };
  return (
    <div className="sliders-table">
      <StripedTable
        thArray={[
          'ترتیب',
          'عنوان اسلایدر',
          'دیوایس اسلایدر',
          'نوع کاربر',
          'افزودن اسلاید',
          'ویرایش',
          'حذف',
        ]}
        tdArray={sliders.docs.map((slider) => [
          slider.order,
          slider.title,
          slider.devices.map((device) => __(device)).join('،'),
          slider.users.map((user) => __(user)).join('،'),
          <IconButton onClick={() => handleAddSlides(slider._id)}>
            <BurstModeIcon />
          </IconButton>,
          <IconButton onClick={() => handleEditSlider(slider._id)}>
            <EditIcon />
          </IconButton>,
          <IconButton onClick={() => handleDeleteSlider(slider._id)}>
            <DeleteIcon />
          </IconButton>,
        ])}
      />
      <Pagination
        activePage={sliders.page}
        itemsCountPerPage={sliders.limit}
        totalItemsCount={sliders.totalDocs}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
      />
    </div>
  );
});

export default SlidersTable;
